<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<a-button class="qinang-button-margin" type="primary" icon="plus" @click="tableAdd">新增</a-button>
				<a-button class="qinang-button-margin" icon="edit" @click="tableEdit" :disabled="!tableSelectedRows.length || tableSelectedRows.length !== 1">修改</a-button>
				<a-button class="qinang-button-margin" icon="delete" @click="tableDel">删除</a-button>
				<a-button icon="sync" @click="apiProductCategoryQueryList">刷新</a-button>
			</div>
		</div>
		
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="产品分类查询">
				<div style="display: flex;justify-content: space-between;align-items: center;">
					<div style="width: 30%;display: flex;align-items: center;">
						<div style="width: 100px;">分类类型</div>
						<a-select v-model="query.facilitatorType" style="width: 100%;" placeholder="请选择分类类型" allowClear>
							<a-select-option v-for="(item,index) in typeList" :value="item.value" :key="index">{{item.label}}</a-select-option>
						</a-select>
					</div>
                    <div style="width: 30%;display: flex;align-items: center;">
						<div style="width: 120px;">分类名称：</div>
						<a-input v-model="query.name" style="width: 100%;" placeholder="请输入分类名称" />
					</div>
					<div style="display: flex; justify-content: flex-end;">
						<a-button type="primary" icon="search" @click="apiProductCategoryQueryList">查询</a-button>
					</div>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			<div style="display: flex;justify-content: space-between;align-items: center;">
				<a-breadcrumb separator=">" style="padding: 12.5px 16px;" >
					<a-breadcrumb-item>
						产品分类列表
					</a-breadcrumb-item>
				</a-breadcrumb>
			</div>
			<a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData" row-key="productCategoryId" :loading="tableLoading" :pagination="false">

				<span slot="name" slot-scope="text, record">
					<a-button type="link" @click="edit(record)" >{{record.name}}</a-button>
				</span>
				<span slot="facilitatorType" slot-scope="facilitatorType">
					{{typeList.find(item => item.value == facilitatorType.facilitatorType)?.label || ''}}
				</span>
                <span slot="createTime" slot-scope="createTime">
					{{qaUtil.timeFormat(createTime.createTime)}}
				</span>
			</a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>


		<!-- 添加弹窗 -->
		<a-modal class="qa-modal-half" title="添加" width="600px" :visible="addVisible" :confirm-loading="addConfirmLoading" @ok="addHandleOk" @cancel="handleCancel" :maskClosable="false" :keyboard="false" >
			<a-form-model ref="addRuleForm" :model="addForm" :label-col="{span: 5}" :wrapper-col="{span: 17}" :rules="addRules">
				<a-form-model-item label="分类名称" has-feedback prop="name">
					<a-input v-model="addForm.name" placeholder="请输入分类名称" />
				</a-form-model-item>
                <a-form-model-item label="分类类型" has-feedback prop="facilitatorType">
					<a-select v-model="addForm.facilitatorType" placeholder="请选择分类类型" allowClear>
						<a-select-option v-for="(item,index) in typeList" :value="item.value" :key="item.priceId">{{item.label}}</a-select-option>
					</a-select>
				</a-form-model-item>
                <a-form-model-item label="分类图标" has-feedback prop="picUrl">
                    <a-upload name="fileName" list-type="picture-card" :show-upload-list="false" :action="navigation.apiUploadFiles" @change="uploadHandleChange" >
                        <img style="height: 86px;height: 86px;object-fit: contain;" v-if="addForm.picUrl" :src="navigation.url + addForm.picUrl" alt="avatar" />
                        <div v-else>
                            <a-icon :type="uploadPublic.loading ? 'loading' : 'plus'" />
                            <div>上传</div>
                        </div>
                    </a-upload>
                </a-form-model-item>
				<a-form-model-item label="排序" has-feedback prop="sort">
					<a-input-number v-model="addForm.sort" placeholder="请输入排序" />
				</a-form-model-item>
				<a-form-model-item label="分类状态" has-feedback prop="state">
					<a-radio-group name="state" v-model="addForm.state">
						<a-radio :value="2">禁用</a-radio>
						<a-radio :value="3">启用</a-radio>
					</a-radio-group>
				</a-form-model-item>
			</a-form-model>
		</a-modal>

		<!-- 修改弹窗 -->
		<a-modal class="qa-modal-half" title="修改" width="600px" :visible="editVisible" :confirm-loading="editConfirmLoading" @ok="editHandleOk" @cancel="handleCancel" :maskClosable="false" :keyboard="false" >
			<a-form-model ref="editRuleForm" :model="editForm" :label-col="{span: 5}" :wrapper-col="{span: 17}" :rules="addRules">
				<a-form-model-item label="分类名称" has-feedback prop="name">
					<a-input v-model="editForm.name" placeholder="请输入分类名称" />
				</a-form-model-item>
                <a-form-model-item label="分类类型" has-feedback prop="facilitatorType">
					<a-select v-model="editForm.facilitatorType" placeholder="请选择分类类型" allowClear>
						<a-select-option v-for="(item,index) in typeList" :value="item.value" :key="item.priceId">{{item.label}}</a-select-option>
					</a-select>
				</a-form-model-item>
                <a-form-model-item label="分类图标" has-feedback prop="picUrl">
                    <a-upload name="fileName" list-type="picture-card" :show-upload-list="false" :action="navigation.apiUploadFiles" @change="uploadHandleChange" >
                        <img style="height: 86px;height: 86px;object-fit: contain;" v-if="editForm.picUrl" :src="navigation.url + editForm.picUrl" alt="avatar" />
                        <div v-else>
                            <a-icon :type="uploadPublic.loading ? 'loading' : 'plus'" />
                            <div>上传</div>
                        </div>
                    </a-upload>
                </a-form-model-item>
				<a-form-model-item label="排序" has-feedback prop="sort">
					<a-input-number v-model="editForm.sort" placeholder="请输入排序" />
				</a-form-model-item>
				<a-form-model-item label="分类状态" has-feedback prop="state">
					<a-radio-group name="state" v-model="editForm.state">
						<a-radio :value="2">禁用</a-radio>
						<a-radio :value="3">启用</a-radio>
					</a-radio-group>
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		
		
	</div>
</template>

<script>
	import moment from 'moment'
	export default {
		data() {
			return {
				moment,
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				//类型列表
				typeList: [
                     {
                        label:'景区',
                        value:1
                    },
                    {
                        label:'零售',
                        value:2
                    },
                    {
                        label:'餐饮',
                        value:3
                    },
                    {
                        label:'酒店',
                        value:4
                    },
                ],
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					facilitatorType: undefined,
					name: '',
				},
				mainNavigation:{},
				tableData: [],
				tableColumns: [
                    { title:'ID', dataIndex:'productCategoryId', key:'productCategoryId', align:'center'},
					{ title:'分类名称', key:'name', align:'center',scopedSlots:{customRender:'name'}},
					{ title:'分类类型', key:'facilitatorType', align:'center', scopedSlots:{customRender:'facilitatorType'}},
					{ title:'添加时间', key:'createTime', align:'center', scopedSlots:{customRender:'createTime'}},
					
				],
				tableLoading: false,
				tableSelectedRows: [],
				//搜索+表格-end
				// 添加弹窗-start
				addVisible: false,
				addConfirmLoading: false,
				addForm: {
					facilitatorType: undefined,
					name: '',
					picUrl: '',
					sort: 0,
					state:3,
				},
				addRules: {
					sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
					name: [{ required: true, message: '分类名称不能为空', trigger: 'blur' }],
					facilitatorType: [{ required: true, message: '分类类型不能为空', trigger: 'change' }],
					// priceId: [{ required: true, message: '请选择产品', trigger: 'change' }],
				},
				// 添加弹窗-end
				// 修改弹窗-start
				editVisible: false,
				editConfirmLoading: false,
				editForm: {
					productCategoryId: undefined,
					facilitatorType: undefined,
					name: '',
					picUrl: '',
					sort: 0,
					state:3,
				},
				// 修改弹窗-end
                //图片上传-开始-----------------------------------------------------
				uploadPublic: {
					loading: false,
					taskName: 'add',
				},
				//图片上传-结束
			};
		},
		methods: {

			//--------------表格开始-搜索
			async apiProductCategoryQueryList() {
				this.tableLoading = true
				const {
					data: res
				} = await this.$http.post(this.navigation.apiProductCategoryQueryList, this.query);
				if (res.code == 200) {
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
					// this.$message.success(res.msg)
					this.tableLoading = false
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiProductCategoryQueryList()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiProductCategoryQueryList()
			},
			handleCancel() {
				this.addVisible = false
				this.editVisible = false

			},

			// 添加
			tableAdd() {
				this.addVisible = true
				this.addConfirmLoading = false
				this.addForm = {
					facilitatorType: undefined,
					name: '',
					picUrl: '',
					sort: 0,
					state:3,
				}
				if(this.$refs.addRuleForm) {
					this.$refs.addRuleForm.resetFields();
				}
                this.uploadPublic.taskName = 'add'
			},
			async apiProductCategoryAdd() {
				this.addConfirmLoading = true
				const {
					data: res
				} = await this.$http.post(this.navigation.apiProductCategoryAdd, this.addForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					if(this.$refs.addRuleForm) {
						this.$refs.addRuleForm.resetFields();
					}
					this.addConfirmLoading = false
					this.addVisible = false
					// 等待弹窗关闭后再刷新列表
					this.apiProductCategoryQueryList()
				} else {
					this.$message.error(res.msg)
					this.addConfirmLoading = false
				}
			},
			addHandleOk() {
				this.$refs.addRuleForm.validate(valid => {
					if (valid) {
						this.apiProductCategoryAdd()
					} else {
						return false;
					}
				});
			},

			// 修改
			async edit(item){
				this.editConfirmLoading = false
				// 设置表单数据，确保 priceIdList 属性存在
				this.editForm = item
                this.uploadPublic.taskName = 'edit'
				// 先打开弹窗
				this.editVisible = true

			},
			async apiProductCategoryEdit() {
				this.editConfirmLoading = true
				const {
					data: res
				} = await this.$http.post(this.navigation.apiProductCategoryEdit, this.editForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.editConfirmLoading = false
					this.editVisible = false
					// 等待弹窗关闭后再刷新列表
					this.apiProductCategoryQueryList()
				} else {
					this.$message.error(res.msg)
					this.editConfirmLoading = false
				}
			},
			editHandleOk() {
				this.$refs.editRuleForm.validate(valid => {
					if (valid) {
						this.apiProductCategoryEdit()
					} else {
						return false;
					}
				});
			},
			editHandleCancel() {
				this.editVisible = false
			},
			//删除
			tableDel() {
				let that = this
				if(this.tableSelectedRows.length > 0) {
					const ids = this.tableSelectedRows.map(row=>row.productCategoryId)
					this.$confirm({
						title: '确定要删除当前选中数据吗',
						content: '当前选中' + ids.length + '条数据。',
						okText: '确定',
						okType: 'danger',
						cancelText: '取消',
						onOk() {
							that.apiProductCategoryDel(ids)
						},
						onCancel() {
						},
					});
				}else{
					this.$message.warning('请选择要删除的数据');
				}
			},
			//删除
			async apiProductCategoryDel(ids) {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiProductCategoryDel + '/'+ ids);
				if (res.code == 200) {
					this.$message.success(res.msg)
					await this.apiProductCategoryQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},
			tableEdit() {
				if(this.tableSelectedRows.length === 1) {
					const item = this.tableData.find(item => item.productCategoryId == this.tableSelectedRows[0].productCategoryId)
					this.edit(item)
				}else{
					this.$message.warning('请选择要修改的数据');
				}
			},
            //文件上传-开始
			beforeUpload(file) {
				const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
				// if (!isJpgOrPng) {
				// 	this.$message.error('You can only upload JPG file!');
				// }
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('请上传小于 2MB 的图片!');
				}
				return isJpgOrPng && isLt2M;
			},
			uploadHandleChange(info) {
				if (info.file.status === 'uploading') {
					this.uploadPublic.loading = true;
					return;
				}
				console.log(info)
				if (info.file.status === 'done') {
					if (this.uploadPublic.taskName == 'add')this.addForm.picUrl = info.file.response.data
					if (this.uploadPublic.taskName == 'edit')this.editForm.picUrl = info.file.response.data
					this.uploadPublic.loading = false;
				}
			},
			//文件上传-结束
			
		},
		computed: {
			rowSelection() {
				let that = this
				return {
					onChange: (selectedRowKeys, selectedRows) => {
						that.tableSelectedRows = selectedRows;
					},
					// getCheckboxProps: record => ({
					// 	props: {
					// 		disabled: record.name === 'Disabled User', // Column configuration not to be checked
					// 		name: record.name,
					// 	},
					// }),
				};
			},
		},
		created() {
            this.apiProductCategoryQueryList()
		}
	};
</script>

<style scoped>

</style>
